// src/helpers/factories/menu/cardFactories/categories/menuCategoryAssignedItemsFactory.ts
var menuCategoryAssignedItemsFactoryCore = (elements, menuTypes, subcategoryMenuTypeElementIds, handleDeleteItem) => {
  const menuTypeItemCards = [];
  Object.entries(subcategoryMenuTypeElementIds).forEach(
    ([, menuTypeItemIds]) => {
      Object.entries(menuTypeItemIds).forEach(([menuTypeId, itemIds]) => {
        itemIds.forEach((itemId) => {
          var _a;
          const item = elements[itemId];
          const id = (item == null ? void 0 : item.itemId) || (item == null ? void 0 : item.comboId);
          if (item) {
            menuTypeItemCards.push({
              id,
              menuTypeId: Number(menuTypeId),
              title: item.name,
              onDelete: () => handleDeleteItem(id, Number(menuTypeId)),
              onPress: () => console.info(itemId),
              description: menuTypes[Number(menuTypeId)].name,
              idKey: `${menuTypeId}-${itemId}`,
              isActive: (_a = item.menuTypeVersions[Number(menuTypeId)]) == null ? void 0 : _a.active
            });
          }
        });
      });
    }
  );
  return menuTypeItemCards;
};

export { menuCategoryAssignedItemsFactoryCore };
